import React from "react";
import TextArea from "../textArea/TextArea";
import {LightingTextWrapper} from "./LightingTextStyled";

type IProps = {
    showPopup?: boolean;
}

const CareerWorkerLightingText = ({
                                      showPopup = false
                                  }: IProps) => {
    return (
        <LightingTextWrapper className={showPopup ? 'popup-wrapper' : undefined}>
            <TextArea>
                <h2 className={showPopup ? 'popup-wrapper-title' : undefined}>Kişisel Verilerin Korunması</h2>
                <h3 style={{marginTop: 0}}>
                    Çalışan Adayı Aydınlatma Metni
                </h3>
                <p>
                    <span style={{fontWeight: 'bold'}}>
                        Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş. (Panjur Bilişim), veri sorumlusu olarak
                        6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili diğer mevzuata uygun olarak
                        kişisel verilerinizi işlemektedir.
                    </span>
                </p>

                <p>
                    <span style={{fontWeight: 'bold'}}>
                        KVKK'nun Aydınlatma Yükümlülüğü'nü düzenleyen 10'ncu maddesine göre veri sorumluları, kişisel
                        verilerini işledikleri ilgili kişileri belirli konularda bilgilendirmekle yükümlüdür.
                    </span>
                </p>

                <p>
                    <span style={{fontWeight: 'bold'}}>
                        Bu aydınlatma metni de hukuki yükümlülüğün yerine getirilebilmesi amacıyla Kişisel Verileri Koruma
                        Kurumu tarafından yayınlanan Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak Usul ve
                        Esaslar Hakkında Tebliğ'ine uygun olarak hazırlanmıştır.
                    </span>
                </p>

                <h3 style={{marginTop: 0}}>
                    Tanımlar
                </h3>
                <p>
                    6698 sayılı Kişisel Verilerin Korunması Kanunu'na göre:
                </p>
                <p>
                    Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi;
                </p>
                <p>
                    Kişisel verilerin işlenmesi, kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi bir
                    veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi,
                    depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması,
                    devralınması, elde edilebilir hâle getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi
                    gibi veriler üzerinde gerçekleştirilen her türlü işlemi;
                </p>
                <p>
                    İlgili kişi, kişisel verisi işlenen gerçek kişiyi;
                </p>
                <p>
                    Veri sorumlusu, kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt
                    sisteminin kurulmasından ve yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi
                </p>
                <p>
                    Aydınlatma yükümlülüğü, kişisel verilerin elde edilmesi sırasında veri sorumlusu veya
                    yetkilendirdiği kişinin, ilgili kişilere; veri sorumlusunun kimliği, kişisel verilerin hangi amaçla
                    işleneceği, işlenen kişisel verilerin kimlere ve hangi amaçla aktarılabileceği, kişisel veri
                    toplamanın yöntemi ve hukuki sebebi ve Kanun'un 11'inci maddesinde sayılan diğer hakları konusunda
                    bilgi verme yükümlülüğünü; ifade eder.
                </p>

                <h3 style={{marginTop: 0}}>
                    İlgili Kişi
                </h3>
                <p>
                    Kişisel verileri <span style={{fontWeight: 'bold'}}>Panjur Bilişim</span> tarafından işlenen siz, iş
                    başvurunuz sebebiyle <span style={{fontWeight: 'bold'}}>Çalışan Adayı</span> olarak
                    tanımlanmakta ve Kanun tarafından da İlgili Kişi olarak kabul edilmektesiniz.
                </p>
                <h3 style={{marginTop: 0}}>
                    Veri Sorumlusu
                </h3>
                <p>
                    Sizinle ilgili kişisel veriler konusunda kişisel verilerin işleme amaçlarını ve vasıtalarını
                    belirleyen, veri kayıt sisteminin kurulmasından ve yönetilmesinden sorumlu olan <span
                    style={{fontWeight: 'bold'}}>Panjur Bilişim</span> veri
                    sorumlusudur.
                </p>
                <h3 style={{marginTop: 0}}>
                    Kişisel Verilerinizin Elde Edilmesi
                </h3>
                <p>
                    Başvurunuz ve özgeçmişinize ilişkin kişisel verileriniz, web sitemizdeki kariyer sayfası, breezy,
                    e-posta, kariyer.net ve linkedin gibi platformlar ile diğer kanallar üzerinden, elektronik ortamda,
                    tamamen veya kısmen otomatik sistemler aracılığı ile elde edilmektedir.
                </p>
                <h3 style={{marginTop: 0}}>
                    Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri
                </h3>
                <p>
                    Firmamıza iş başvurusu yapmanız halinde;
                </p>
                <ul>
                    <li style={{listStyle: 'disc'}}>
                        Kimlik, iletişim, adres, çalışmak istediğiniz pozisyon bilgileri, başvuru ile ilgili ön yazınız
                        ile özgeçmişinizde yer alan öğrenim bilgileriniz, başvurduğunuz pozisyona ilişkin beceriler,
                        mesleki deneyim bilgileriniz, özgeçmişinizde yer alan diğer kişisel verileriniz ile başvuru
                        formunda belirttiğiniz kişisel verileriniz,
                    </li>
                </ul>
                <p>
                    <span
                        style={{fontWeight: 'bold'}}>Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi</span> amacıyla
                    açık rızanıza istinaden (KVKK Md.5/1
                    kapsamında) işlenmektedir.
                </p>
                <p>
                    Bunların yanında
                </p>
                <ul>
                    <li style={{listStyle: 'disc'}}>
                        Özgeçmişinizde referans olarak belirttiğiniz kişilerden hakkınızda edineceğimiz bilgileriniz,
                    </li>
                    <li style={{listStyle: 'disc'}}>
                        Başvurunuz sonrası mülakata çağırılmanız halinde, burada bize bildirdiğiniz bilgileriniz,
                    </li>
                </ul>
                <p>
                    <span style={{fontWeight: 'bold'}}>Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi ile Çalışan Adayı Seçme ve Yerleştirme
                        Süreçlerinin Yürütülmesi</span> amaçlarıyla tarafınızla iş sözleşmesi kurulması sebebine
                    istinaden (KVKK
                    Md.5/2(c) kapsamında) işlenmektedir.
                </p>
                <p>
                    Bu bilgileriniz iş başvurunuzun reddi halinde Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi
                    amacıyla KVKK Md.5/2e'deki bir hakkın tesisi, kullanılması veya korunması için veri işlemenin
                    zorunlu olması sebebiyle bir süre saklandıktan sonra imha edilmektedir.
                </p>
                <p>
                    Talebiniz doğrultusunda başvurunuzun havuzda bekletilmesi kararı alınması halinde Çalışan
                    Adaylarının Başvuru Süreçlerinin ve Saklama ve Arşiv Faaliyetlerinin Yürütülmesi amaçlarıyla KVKK
                    Md.5/1'deki açık rızanız bulunması halinde bu sebebe dayanılarak bir süre saklandıktan sonra imha
                    edilmektedir.
                </p>
                <p>
                    Verdiğiniz rızalar ile aydınlatma metinlerini okuduğunuza ilişkin kayıtlar, faaliyetlerin mevzuata
                    uygun yürütülmesi amacıyla VKK Md.5/2e'deki bir hakkın tesisi, kullanılması veya korunması için veri
                    işlemenin zorunlu olması sebebiyle işlenir.
                </p>
                <p>
                    İşe kabulünüz halinde bu bilgileriniz imha edilmeyip çalışan özlük dosyanız içerisinde çalışanın iş
                    akdi ve mevzuattan kaynaklı yükümlülüklerin yerine getirilmesi amacı ve KVKK Md.5/2ç’deki veri
                    sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması sebebiyle saklanmaya
                    devam edecektir.
                </p>
                <p>
                    Bize ilettiğiniz bilgiler arasından başta özel nitelikli kişisel verileriniz (dernek, vakıf üyeliği,
                    sağlık durumu gibi) olmak üzere bizimle çalışmanız için gerekmeyen bilgileri özgeçmişinizden
                    kaldırarak özgeçmişinizi göndermenizi öneririz.
                </p>
                <p>
                    Özgeçmişinizde referans olarak bildirdiğiniz kişinin bilgilerini bizimle paylaşmak için rızasını
                    aldığınız kabul edilir.
                </p>
                <h3 style={{marginTop: 0}}>
                    Kişisel Verilerinizin Aktarılması
                </h3>
                <p>
                    Kişisel verileriniz KVKK Md.28/1 çerçevesinde talep edilmesi halinde aydınlatma yükümlülüğü olmadan
                    ve açık rızanız aranmadan ilgili makamlara aktarılabilir.
                </p>
                <p>
                    Bunun dışında öngörülemeyen durumlarda da kişisel verileriniz kanunlarda açıkça belirtilmiş
                    durumlarda talep edilmesi halinde kanunlarda belirtilen kamu kurumlarına (bakanlıklar gibi idari
                    makamlara) kanunda öngörülen amaç ve sınırlamalar dâhilinde aktarılabilir.
                </p>
                <p>
                    Kişisel verileriniz, aydınlatma yükümlülüğü olmayan ve açık rızanızı gerektirmeyen yasal
                    yükümlülüklerimizin dışında; başvurularınızı toplayabilmek amacıyla kullandığımız tedarikçilerimiz
                    aracılığı ile tarafımıza aktarılır.
                </p>
                <h3 style={{marginTop: 0}}>
                    Kişisel Verilerinizle İlgili Haklarınız
                </h3>
                <p>
                    İlgili kişiler kişisel verilerine ilişkin haklarını kullanmak için öncelikle veri sorumlusuna
                    başvurmak zorundadırlar. Kanunun 14'üncü maddesine göre Kişisel Verileri Koruma Kurulu'na doğrudan
                    şikâyette bulunulamaz.
                </p>
                <p>
                    Kanun uyarınca kişisel verilerinizle ilgili
                </p>
                <ul>
                    <li>
                        Kişisel veri işlenip işlenmediğini öğrenme,
                    </li>
                    <li>
                        Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
                    </li>
                    <li>
                        Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
                        öğrenme,
                    </li>
                    <li>
                        Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
                    </li>
                    <li>
                        Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,
                    </li>
                    <li>
                        İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini
                        veya yok edilmesini isteme,
                    </li>
                    <li>
                        (e) ve (f) bentleri uyarınca yapılan işlemlerin, kişisel verilerinizin aktarıldığı üçüncü
                        kişilere bildirilmesini isteme,
                    </li>
                    <li>
                        İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
                        aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
                    </li>
                    <li>
                        Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın
                        giderilmesini talep etme
                    </li>
                </ul>
                <p>
                    Haklarınızı veri sorumlusuna yani bize başvurarak kullanabilirsiniz.
                </p>
                <h3 style={{marginTop: 0}}>
                    Veri Sorumlusuna Başvuru Yöntemi
                </h3>
                <p>
                    Başvurunuzu
                </p>
                <ul>
                    <li style={{listStyle: 'disc'}}>
                        <span style={{fontWeight: 'bold'}}>Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264 Bakırköy, İstanbul</span>
                        adresine yazılı olarak;
                    </li>
                    <li style={{listStyle: 'disc'}}>
                        <a href="mailto:panjur.bilisim@hs02.kep.tr"
                           style={{color: '#000', fontWeight: 'bold'}}>panjur.bilisim@hs02.kep.tr</a> kayıtlı
                        elektronik posta adresine kayıtlı elektronik posta
                        adresinizi kullanarak;
                    </li>
                    <li style={{listStyle: 'disc'}}>
                        Sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanarak
                        <a href="mailto:kvk@pembepanjur.com"
                           style={{color: '#000', fontWeight: 'bold'}}> kvk@pembepanjur.com
                        </a> adresine e-posta göndererek gerçekleştirebilirsiniz.
                    </li>
                </ul>
                <p>
                    Başvuru yapılırken uyulması gereken usul ve esaslar hakkındaki daha detaylı bilgiye Kişisel
                    Verileri Koruma Kurumu'nun Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ'den
                    ulaşabilirsiniz.
                </p>
            </TextArea>
        </LightingTextWrapper>
    )

}

export default CareerWorkerLightingText;